import React from "react";

import MainForm from "./MainForm";
import DateControl from "../custom field control types/DateControl";
import DropDownControl from "../custom field control types/DropDownControl";
import TextFieldControl from "../custom field control types/TextFieldControl";
import RangeControl from "../custom field control types/RangeControl";

export default function FormDisplay({
  groups,
  formikProps,
  controlTypes,
  setControlTypes,
  editState,
  PlatformTenantList,
}) {
  return (
    <React.Fragment>
      <MainForm
        groups={groups}
        formikProps={formikProps}
        controlTypes={controlTypes}
        setControlTypes={setControlTypes}
        editState={editState}
        PlatformTenantList={PlatformTenantList}
      />
      {parseInt(formikProps.values.controlID) === 1 && (
        <RangeControl formikProps={formikProps} editState={editState} />
      )}

      {parseInt(formikProps.values.controlID) === 3 && (
        <TextFieldControl formikProps={formikProps} editState={editState} />
      )}

      {parseInt(formikProps.values.controlID) === 4 && (
        <DateControl formikProps={formikProps} editState={editState} />
      )}

      {parseInt(formikProps.values.controlID) === 2 && (
        <DropDownControl formikProps={formikProps} editState={editState} />
      )}
    </React.Fragment>
  );
}
